"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appAffiliateTrackingType = exports.appAffiliatePrepopulatedUserType = exports.affiliateType = exports.affiliateApplicationType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var affiliateApplicationType = _propTypes.default.shape({
  applicationUuid: _propTypes.default.string,
  type: _propTypes.default.string
});

exports.affiliateApplicationType = affiliateApplicationType;

var affiliateType = _propTypes.default.shape({
  affiliateId: _propTypes.default.string,
  type: _propTypes.default.string
});

exports.affiliateType = affiliateType;

var appAffiliateTrackingType = _propTypes.default.shape({
  application: affiliateApplicationType,
  affiliate: affiliateType,
  eventNames: _propTypes.default.arrayOf(_propTypes.default.string)
});

exports.appAffiliateTrackingType = appAffiliateTrackingType;

var appAffiliatePrepopulatedUserType = _propTypes.default.shape({
  name: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string
  }),
  address: _propTypes.default.shape({
    street1: _propTypes.default.string,
    street2: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    zip: _propTypes.default.string,
    type: _propTypes.default.string
  }),
  email: _propTypes.default.string,
  dob: _propTypes.default.string,
  income: _propTypes.default.number,
  helocReason: _propTypes.default.string,
  trackingNumber: _propTypes.default.string
});

exports.appAffiliatePrepopulatedUserType = appAffiliatePrepopulatedUserType;